export default __webpack_public_path__ + "static/media/moon_symbol.3ad86627.png";